module.exports = __webpack_public_path__ + "static/media/activity-places-icon.f09ae383.svg";